import React from "react";
import GlobalStyles from "./components/globals/GlobalStyles";
import Route from "./routes/routes";

function App() {
  return (
    <div>
      <GlobalStyles />
      <Route />
    </div>
  );
}

export default App;
